/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { fullName, chiefAccountant, signer, timeSign } = formField;

  return (
    <Box mt={3}>
      <Grid container spacing={3}>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={fullName.label}
            name={fullName.name}
            value={values.fullName}
            error={errors.fullName && touched.fullName}
            success={values.fullName?.toString().length > 0 && !errors.fullName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={signer.label}
            name={signer.name}
            value={values.signer}
            error={errors.signer && touched.signer}
            success={values.signer?.toString().length > 0 && !errors.signer}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={chiefAccountant.label}
            name={chiefAccountant.name}
            value={values.chiefAccountant}
            error={errors.chiefAccountant && touched.chiefAccountant}
            success={values.chiefAccountant?.toString().length > 0 && !errors.chiefAccountant}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={timeSign.label}
            name={timeSign.name}
            error={errors.timeSign && touched.timeSign}
            success={values.timeSign?.toString().length > 0 && !errors.timeSign}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
